<script setup>
  import { useTemplateRef } from 'vue';
  import ProForecastContent from '@/components/ProForecastContent.vue';
  import ProForecastUpgradeContent from '@/components/ProForecastUpgradeContent.vue';

  const containerContent = useTemplateRef('container-content');

  const props = defineProps({
    memberLevel: {
      type: [Number, String],
      required: true
    },
    minHeight: {
      type: String,
      default: '0px'
    },
    collapsible: {
      type: Boolean,
      default: true
    },
    containerSettings: {
      type: Object,
      required: false
    }
  });  

  const getSettings = () => {
    if (containerContent.value) {
      return containerContent.value.getSettings();
    }

    return null;
  };

  defineExpose({ getSettings });
</script>

<template>
  <ProForecastContent
    ref="container-content"
    v-if="memberLevel >= 49"
    :minHeight="props.minHeight"
    :collapsible="props.collapsible"
    :containerSettings="props.containerSettings"
  />
  <ProForecastUpgradeContent v-else />
</template>